@if(showCookieBanner && !hideOnImpervaPage){
  <mat-card class="cookie-banner">
    <div class="container">
      <div class="cookie-content">
      <div class="cookie-text">
        <h3>We use cookies to improve your experience.</h3>
        <p>
          {{ cookieText | truncateWords:35 }}
          <a class="cursor-pointer text-decoration-underline" href="https://www.saudia.com/en-IN/information/terms-and-conditions/cookie-policy" target="_blank" rel="noopener noreferrer">Read more</a>
        </p>
      </div>
      <div class="cookie-actions">
        <div class="btn-group">
          <button class="button--secondary-small" mat-button (click)="declineCookies()">
            Decline
          </button>
          <button class="button--primary-small" mat-button (click)="acceptCookies()">
            <mat-icon fontSet="material-symbols-outlined">check</mat-icon>Accept
          </button>
        </div>
      </div>
    </div>
    </div>
  </mat-card>
}